import {
  AnalyticsEntityType,
  AnalyticsSource,
  useAnalyticsContext,
} from '@b-stock/fe-core/bstock-react'

import { useListingSearch } from '@/components/listings/search/ListingSearchProvider'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

/**
 * Shared freeze/unfreeze logic + freeze_sort_toggled tracking (GLOB-4832) for
 * every UI entry point that can flip isSortFrozen — the toolbar toggle, the
 * mobile filters modal toggle, and the "Sort frozen" banner's Unfreeze link —
 * so they all fire the same analytics event regardless of which one the
 * buyer used.
 */
export const useFreezeSortToggle = (pageType: 'alp' | 'storefront') => {
  const { track } = useAnalytics()
  const { screenName } = useAnalyticsContext()
  const { data, state, setSortFrozen } = useListingSearch()

  const setFrozen = (nextValue: boolean) => {
    track('freeze_sort_toggled', {
      screenName,
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
      state: nextValue ? 'on' : 'off',
      page_type: pageType,
      sort_option: state.sortBy,
      result_count: data?.total ?? 0,
    })
    setSortFrozen(nextValue)
  }

  return { isFrozen: state.isSortFrozen, setFrozen }
}
